import firebase from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyCo4PPqA0GZDA4NGg_3AAcgv71_0RUf9rE',
  projectId: 'dd-good-cop-bad-cop',
  storageBucket: 'dd-good-cop-bad-cop.appspot.com',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
